import { gql } from '@apollo/client';

import { GraphQLTypes } from 'src/lib/graphqlTypes';

// Ideally we want to have the the default field filter set to All Fields when
// the graph has no field usage. We might not need this query here once
// https://apollographql.atlassian.net/browse/PULSR-464 is done since we'll
// likely have a better way to display fields with no usage.
export const lastReportedQuery = gql<
  GraphQLTypes.LastReportedQuery,
  GraphQLTypes.LastReportedQueryVariables
>`
  query LastReportedQuery($graphId: ID!, $graphVariant: String!) {
    service(id: $graphId) {
      id
      lastReportedAt(graphVariant: $graphVariant)
    }
  }
`;
